import * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { transformsStore } from '../../../../../mobx/transforms.store';
import * as _ from 'lodash';
import ComboBox from '../../../../components/ComboBox/ComboBox';
import ConfirmPopup from '../../../../components/ConfirmPopup/ConfirmPopup';
import TextFieldWrapper from '../../../../components/TextFieldWrapper/TextFieldWrapper';
import Slider from '../../../../components/Slider/Slider';
import { ITransform } from '../../../../../models/ITransform';
import { RectButton } from '../../../../components/buttons/RectButton/RectButton';
import { confirmAlert } from '../../../../../services/mini/alanConfirmAlert';
import { isMaxTokensValid } from '../getTransformText';
import { Button, ButtonTheme } from '../../../../components/Button/Button';

type TransformFiltersProps = {
    filterMsg: string,
    linesFilter?: number[],
}

function TransformFilters({
    filterMsg,
    linesFilter = []
}: TransformFiltersProps) {


    return <div className="transform-filters">
        {linesFilter?.length > 0 ? <>
            <span title={filterMsg} className="icon transform-filters__filter-info">
                <div>{filterMsg}</div>
                <i className="icon icon-alan-info-sign" />
            </span>

            <Button
                theme={ButtonTheme.Blue}
                className="transform-filters__filters-btn"
                label="Clear filters"
                icon={<i className="icon icon-alan-filter" />}
                onClick={() => transformsStore.resetLineFilters()} />
        </> :
            <></>
        }

    </div >;
}

export default observer(TransformFilters);
